module.exports = __webpack_public_path__ + "img/users-slash.49fbb497.svg";